import {KennethMustDie} from "../KennethMustDie";
import {KMDSymbol} from "./KMDSymbol";
import {KMD_SYMBOL_ANIMATIONS, SPECIAL_SYMBOL_NAMES, X_HOLE_ANIMATIONS} from "../server/IKMDData";
import {gsap} from "gsap";
import {KMDSound} from "../sound/KMDSound";
import {KMDGameMode} from "../server/KMDGameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class KMDXHoleSuck {

    private SET: number[][] = [[0, 0], [0, 1], [1, 0], [1, 1], [1, 2], [2, 0], [2, 2], [3, 0], [3, 1], [3, 2], [4, 0], [4, 1]];
    private DISPLACEMENT: number[][] = [[20, 45], [30, 10], [20, -30], [-100, -70], [20, 100], [10, -50], [10, 120], [0, -30], [100, -70], [0, 100], [-20, 45], [-30, 10]];
    private _symbolsCopy: KMDSymbol[];

    public suckAction(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            xHSymbol: KMDSymbol = (KennethMustDie.reelView.reelModels[2].getStopSymbolAt(1).positionable as KMDSymbol),
            multipliers: number[][] = KennethMustDie.model.gameData.multiplier,
            if3ScattersPresent: boolean = (KennethMustDie.s1CountReelStop === 3);

        if (xHSymbol.originalName !== SPECIAL_SYMBOL_NAMES.XH) {
            xHSymbol.originalName = SPECIAL_SYMBOL_NAMES.XH;
            xHSymbol.updateAnimation(SPECIAL_SYMBOL_NAMES.XH);
        }

        tl.add(KennethMustDie.stickyS2.hideLock());

        tl.add([
            () => {
                xHSymbol.parent.addChild(xHSymbol);
                xHSymbol.setState(X_HOLE_ANIMATIONS.SUCK); // keep it here, in SFS the symbol is not XH

                KennethMustDie.stickyXH.hideStickyXH();

                // #432, #479 => in SFS xHole can't be activated in SFS_Avalanche
                KennethMustDie.soundPlayer.playSound(KennethMustDie.model.gameData.mode === KMDGameMode.FREESPIN_SUPER ? KMDSound.X_HOLE_ACTIVATION_FAST : KMDSound.X_HOLE_ACTIVATION);
            },
            KennethMustDie.xHoleOverlayAnimations.playSuck(),
            this.suck(this.SET, if3ScattersPresent)
        ]);

        tl.add(KennethMustDie.xHoleOverlayAnimations.playSuckClose());

        tl.add(this.out(if3ScattersPresent));

        tl.add([
            () => {
                xHSymbol.parent.addChild(xHSymbol);

                // #479
                KennethMustDie.soundPlayer.playSound(KMDSound.WIN_SCRAMBLE);
            },
            xHSymbol.setState(X_HOLE_ANIMATIONS.TO_WILD)
        ]);

        tl.add(() => {
            xHSymbol.updateTexture(SPECIAL_SYMBOL_NAMES.W);

            KennethMustDie.updateWaysOnReelStopActions(multipliers);
        });

        return tl;
    }

    private getSymbolForSuckAction(val: number[]): KMDSymbol {
        return (KennethMustDie.reelView.reelModels[val[0]].getStopSymbolAt(val[1]).positionable as KMDSymbol);
    }

    private suck(set: number[][], if3ScattersPresent: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            symbolsContainer: PIXI.Container = new PIXI.Container();

        this._symbolsCopy = [];
        symbolsContainer.rotation = 0;
        symbolsContainer.position.set(360, 315);

        tl.add(() => {
            for (let i: number = 0; i < set.length; i++) {
                const reelId: number = set[i][0];
                let symId: number = set[i][1];

                // #313
                if (KennethMustDie.stickyWilds.checkIfSticky(reelId, symId) || KennethMustDie.stickyXNudges.checkIfSticky(reelId, symId)) {
                    continue;
                }

                const sym: KMDSymbol = this.getSymbolForSuckAction(set[i]);

                // #347
                if (sym.name === SPECIAL_SYMBOL_NAMES.S && if3ScattersPresent) {
                    continue;
                }

                let x: number = 0,
                    y: number = 0;
                if (reelId < 2) {
                    x = -((2 - reelId) * KennethMustDie.SYMBOL_WIDTH);
                } else if (reelId > 2) {
                    x = ((reelId - 2) * KennethMustDie.SYMBOL_WIDTH);
                }

                symId += (reelId === 0 || reelId === 4 ? 1 : 0);

                if (symId < 1) {
                    y = -((1 - symId) * KennethMustDie.SYMBOL_HEIGHT);
                } else if (symId > 1) {
                    y = ((symId - 1) * KennethMustDie.SYMBOL_HEIGHT);
                }

                if (sym.originalName !== SPECIAL_SYMBOL_NAMES.NW) {
                    symbolsContainer.addChild(sym);
                    sym.position.set(x, y);

                    this._symbolsCopy.push(sym);
                }
            }

            KennethMustDie.xHoleOverlayAnimations.addChildAt(symbolsContainer, 0);

            KennethMustDie.backgroundElements.shake();
            KennethMustDie.reelFrame.shake();
            KennethMustDie.xHoleBlackBg.show(0);
            KennethMustDie.xHoleBlackBg.playFlicker();
        });

        for (let i: number = 0; i < set.length; i++) {
            const reelId: number = set[i][0];
            let symId: number = set[i][1];

            // #313
            if (KennethMustDie.stickyWilds.checkIfSticky(reelId, symId) || KennethMustDie.stickyXNudges.checkIfSticky(reelId, symId)) {
                continue;
            }

            const sym: KMDSymbol = this.getSymbolForSuckAction(set[i]);

            // #347
            if (sym.name === SPECIAL_SYMBOL_NAMES.S && if3ScattersPresent) {
                continue;
            }

            let x: number = 0,
                y: number = 0;
            if (reelId < 2) {
                x = -((2 - reelId) * KennethMustDie.SYMBOL_WIDTH);
            } else if (reelId > 2) {
                x = ((reelId - 2) * KennethMustDie.SYMBOL_WIDTH);
            }

            symId += (reelId === 0 || reelId === 4 ? 1 : 0);

            if (symId < 1) {
                y = -((1 - symId) * KennethMustDie.SYMBOL_HEIGHT);
            } else if (symId > 1) {
                y = ((symId - 1) * KennethMustDie.SYMBOL_HEIGHT);
            }

            if (sym.originalName !== SPECIAL_SYMBOL_NAMES.NW) {
                tl.to(sym.scale, {
                    duration: 6 / 30,
                    x: 0.6,
                    y: 0.6
                }, 0);
                tl.to(sym, {
                    duration: 6 / 30,
                    x: (x + this.DISPLACEMENT[i][0]),
                    y: (y + this.DISPLACEMENT[i][1])
                }, 0);
            }
        }

        tl.to(symbolsContainer, {
            duration: 47 / 30,
            rotation: Math.PI * 4
        }, 7 / 30);

        tl.to(symbolsContainer.scale, {
            duration: 19 / 30,
            x: 0.3,
            y: 0.3
        }, 35 / 30);

        tl.to(symbolsContainer, {
            duration: 5 / 30,
            alpha: 0
        }, 49 / 30);

        tl.add(() => {
            KennethMustDie.backgroundElements.stopShake();
            KennethMustDie.reelFrame.stopShake();

            this._symbolsCopy.forEach((sym: KMDSymbol) => {
                sym.x = 360;
                sym.y = KennethMustDie.SYMBOL_HEIGHT;

                KennethMustDie.reelView.symbolContainer.addChildAt(sym, 0);
            });

            KennethMustDie.xHoleOverlayAnimations.removeChild(symbolsContainer);
            symbolsContainer.removeChildren();
            symbolsContainer.destroy();

            KennethMustDie.xHoleBlackBg.stopFlicker();
            KennethMustDie.xHoleBlackBg.show(0.4);
        });

        this._symbolsCopy = [];

        return tl;
    }

    private out(if3ScattersPresent: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            reelsAfterXHole: string[][] = KennethMustDie.model.gameData.xHoleReels,
            set1: number[][] = [[3, 0], [3, 1], [3, 2]],
            set2: number[][] = [[4, 0], [4, 1]],
            set3: number[][] = [[2, 0], [2, 2]],
            set4: number[][] = [[0, 0], [0, 1]],
            set5: number[][] = [[1, 0], [1, 1], [1, 2]];
        let level: number = 1;

        tl.add(() => {
            KennethMustDie.xHoleBlackBg.show(0.4);
        });

        tl.add(this.blast(level++, set1, if3ScattersPresent, reelsAfterXHole));
        tl.add(this.highlightPotentialWin(set1, [], reelsAfterXHole));

        tl.add(this.blast(level++, set2, if3ScattersPresent, reelsAfterXHole));
        tl.add(this.highlightPotentialWin(set1, [4], reelsAfterXHole));

        tl.add(this.blast(level++, set3, if3ScattersPresent, reelsAfterXHole));
        tl.add(this.highlightPotentialWin(set3, [3, 4], reelsAfterXHole));

        tl.add(this.blast(level++, set4, if3ScattersPresent, reelsAfterXHole));
        tl.add(this.highlightPotentialWin(set4, [2, 3, 4], reelsAfterXHole));

        tl.add(this.blast(level++, set5, if3ScattersPresent, reelsAfterXHole));

        tl.add(KennethMustDie.xHoleBlackBg.hide());

        // #546
        tl.timeScale(KennethMustDie.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? 2.5 : 1.75);

        return tl;
    }

    private blast(level: number, set: number[][], if3ScattersPresent: boolean, reelsAfterXHole: string[][]): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            duration: number = 2 / 30;

        tl.addLabel("doSplit", duration);

        set.forEach((val: number[]) => {
            const sym: KMDSymbol = this.getSymbolForSuckAction(val),
                reelId: number = val[0],
                symId: number = val[1] + (reelId === 0 || reelId === 4 ? 1 : 0),
                multiValue: number = KennethMustDie.model.gameData.multiplier[reelId][symId],
                newName: string = reelsAfterXHole[reelId][symId],
                state: string = KMD_SYMBOL_ANIMATIONS.NORMAL + (Math.min(multiValue, sym.maxSplitParts));

            if (sym.name !== SPECIAL_SYMBOL_NAMES.XH && newName !== SPECIAL_SYMBOL_NAMES.NW && !KennethMustDie.stickyWilds.checkIfSticky(reelId, symId) && !(newName === SPECIAL_SYMBOL_NAMES.S && if3ScattersPresent)) {
                tl.add(() => {
                    sym.updateTexture(newName);
                    sym.parent.addChild(sym);

                    KennethMustDie.winOverlays.playLightSweepFrameHighlight(reelId, symId);
                }, 0);
                tl.to(sym, {
                    duration: duration,
                    alpha: 1
                }, 0);
                tl.to(sym.scale, {
                    duration: duration,
                    x: 1,
                    y: 1
                }, 0);
                tl.to(sym, {
                    duration: duration,
                    x: ((KennethMustDie.SYMBOL_WIDTH * val[0]) + (KennethMustDie.SYMBOL_WIDTH / 2)),
                    y: (symId * KennethMustDie.SYMBOL_HEIGHT)
                }, 0);

                if (sym.originalName === SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD) {
                    tl.add(() => {
                        sym.removeMultiplierOnXNudge();
                        sym.showMultiplierOnXNudge(multiValue, -1);
                    }, "doSplit");
                } else if (["S", "S2", "X_WAYS"].indexOf(newName) > -1) {
                    tl.add(() => {
                        sym.showSymbolCount(multiValue);
                    }, "doSplit");
                } else {
                    tl.add([
                        () => {
                            sym.setSplitState(multiValue);
                        },
                        KennethMustDie.winOverlays.playLightSweepAnimation(state, reelId, symId)
                    ], "doSplit");
                }
            }
        });

        // in sticky xNudge case, there can be chances when nothing is spit out
        if (tl.totalDuration()) {
            tl.add([
                KennethMustDie.xHoleOverlayAnimations.playBlast(level),
                KennethMustDie.backgroundElements.pump(duration),
                KennethMustDie.reelFrame.pump(duration),
                KennethMustDie.xHoleBlackBg.pump(duration),
                () => {
                    // #432
                    KennethMustDie.soundPlayer.playSound(KMDSound.X_HOLE_BLAST[level - 1]);
                }
            ], 0);
        }

        return tl;
    }

    private highlightPotentialWin(set1: number[][], reelIdsToCheck: number[], reelsAfterXHole: string[][]): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        set1.forEach((val: number[]) => {
            const reelId: number = val[0],
                symId: number = (val[1] + (reelId === 0 || reelId === 4 ? 1 : 0)),
                symName: string = reelsAfterXHole[reelId][symId];
            let symbolIdxToHighlight: number[][] = [];

            if (this.checkIfPayingSymbol(symName)) {
                for (let nextReelIds: number = 0; nextReelIds < reelIdsToCheck.length; nextReelIds++) {
                    const nextReelId: number = reelIdsToCheck[nextReelIds];
                    let symbolFound: boolean = false;

                    for (let symIds: number = 0; symIds < 3; symIds++) {
                        if ((nextReelId === 0 || nextReelId === 4) && symIds === 0) {
                            continue;
                        }

                        const nextSymName: string = reelsAfterXHole[nextReelId][symIds],
                            effectiveSymIds: number = ((nextReelId === 0 || nextReelId === 4) ? (symIds - 1) : symIds);

                        if ((symName === nextSymName) || (["W", "X_NUDGE_WILD", "NW"].indexOf(nextSymName) > -1)) {
                            symbolFound = true;

                            symbolIdxToHighlight.push([nextReelId, effectiveSymIds]);
                        }
                    }

                    if (!symbolFound) {
                        break;
                    }
                }

                const sym: KMDSymbol = this.getSymbolForSuckAction(val);

                tl.add(sym.playXHolePotentialHighlight(), 0);

                symbolIdxToHighlight.forEach((set2Val: number[]) => {
                    const symInSet2: KMDSymbol = this.getSymbolForSuckAction(set2Val);

                    tl.add(symInSet2.playXHolePotentialHighlight(), 0);
                });
            }
        });

        if (reelIdsToCheck[0] !== 2) {
            const xHSym: KMDSymbol = this.getSymbolForSuckAction([2, 1]);
            tl.add(xHSym.playXHolePotentialHighlight(), 0);
        }

        return tl;
    }

    private checkIfPayingSymbol(name: string): boolean {
        return ["M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "L5", "W", "X_NUDGE_WILD", "NW"].indexOf(name) > -1;
    }
}